import type { ReactNode } from "react";
import { useFormContext } from "react-hook-form";

import { ui } from "@patient-watch/ui";
import { getTestId } from "./utils/getTestId";
import type { LooseRHFField } from "./utils/loose-rhf-field";

interface Props {
    name?: string;
    /** Defaults to `Last Name`. */
    label?: ReactNode;
    placeholder?: string;
}

const Lastname: React.FC<Props> = ({ name = "last_name", label = "Last Name", placeholder = "e.g. Holmes" }) => {
    const { control } = useFormContext();

    return (
        <ui.FormField
            control={control}
            name={name}
            render={({ field }: { field: LooseRHFField }) => (
                <ui.FormItem>
                    <ui.FormLabel>{label}</ui.FormLabel>
                    <ui.FormControl>
                        <ui.Input
                            type="text"
                            placeholder={placeholder}
                            {...field}
                            data-testid={getTestId(name, "input")}
                        />
                    </ui.FormControl>
                    <ui.FormMessage />
                </ui.FormItem>
            )}
        />
    );
};

export default Lastname;
